// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__IBJlj","question":"Question_question__3yU5b","description":"Question_description__1zCbS"};